import React, { useState } from 'react'
import axios from 'lib/axios'
import clsx from 'clsx'

const BADGE_CONFIG = {
  complete:  { icon: 'fas fa-circle-check dome-color-dark-green', label: 'finished' },
  view_only: { icon: 'far fa-eye', label: 'view only' },
}
const DEFAULT_BADGE = { icon: 'fas fa-pen', label: 'for applicant or applicant agent' }

const LOCKED_TOOLTIP =
  'This address can only be updated prior to submission. Acknowledgments will be sent to the ' +
  'parties below. Please contact your property management with any concerns.'


const EditFormBtn = ({ canEdit, onEdit }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <div className='dome-relative'>
      {canEdit ? (
        <button onClick={onEdit} className="dome-btn dome-btn-link dome-btn-link-aqua">
          <span>edit form</span>
          <i className='far fa-arrow-right-long dome-p4' />
        </button>
      ) : (
        <>
          <button className="compliance-form-edit-locked dome-btn dome-btn-link dome-btn-link-disabled" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
            edit form
            <i className='far fa-arrow-right-long dome-p4' />
          </button>
          <div className={clsx('compliance-form-edit-locked-tooltip dome-absolute dome-light-shadow dome-bg-fill dome-rounded-border dome-padding6-12 dome-p3 dome-color-dark-grey', hovered ? 'show-tooltip' : '')}>
            <div className='dome-p2 dome-color-darkest-grey'>why can't I edit?</div>
            {LOCKED_TOOLTIP}
          </div>
        </>
      )}
    </div>
  )
}

export default function Available({ packageHashedId, onBegun, isAvailable, state, canEdit, onEdit }) {
  const badge = BADGE_CONFIG[state] || DEFAULT_BADGE
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleBegin = async () => {
    setLoading(true)
    setError(null)
    try {
      await axios.post(`/package_hook/${packageHashedId}/ny_1120b/compliance_form/begin`)
      setLoading(false)
      onBegun()
    } catch {
      setError('Unable to begin form. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className="compliance-form-card dome-d-flex dome-flex-column dome-gap6">
      <div className="dome-d-flex dome-align-center dome-justify-between">
        <div className='dome-h4'>nyc law compliance form</div>
        <div className="compliance-form-badge dome-bg-lighter-blue dome-d-flex dome-align-center dome-gap6">
          <i className={badge.icon} />
          <span>{badge.label}</span>
        </div>
      </div>
      <div className='dome-d-flex dome-align-center dome-gap6'>
        <div>This form is required for the Applicant or Applicant Agent only.</div>
        {state === 'complete' && (
          <EditFormBtn canEdit={canEdit} onEdit={onEdit}/>
        )}
        {state !== 'complete' && state !== 'view_only' && (
          <button onClick={handleBegin} disabled={!isAvailable || loading} className={clsx("dome-btn dome-btn-link", isAvailable ? 'dome-btn-link-aqua' : 'dome-color-disabled')}>
            <span>begin form</span>
            <i className='far fa-arrow-right-long dome-p4' />
          </button>
        )}
      </div>
      {error && <div className="compliance-form-error">{error}</div>}
    </div>
  )
}
